import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { Card, CardHeader, CardBody, CardFooter } from "reactstrap";

function LineChart({ data }) {
    const [lineChartData, setLineChartData] = useState({
        labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        datasets: [
            {
                label: "Events Count",
                borderColor: "#4caf50",
                fill: true,
                data: [0, 1, 0, 6, 0, 0, 9, 0, 0, 4, 0, 8]
            }
        ],
    });

    useEffect(() => {
        updateLineChartData(data)
    }, [data])

    const updateLineChartData = (data) => {
        const labels = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        const counts = data?.totalCountArray || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        if (counts.length !== labels.length) {
            while (counts.length < labels.length) counts.push(0);
            counts.length = labels.length;
        }
        setLineChartData({
            labels,
            datasets: [
                {
                    label: 'Events Count',
                    data: counts,
                    fill: true,
                    borderColor: 'rgba(75,192,192,1)'
                }
            ]
        });
    };

    return (
        <>
            <Card className="card-chart">
                <CardHeader>
                    <p className="card-category">Month Wise Breakup</p>
                </CardHeader>
                <CardBody>
                    <Line
                        data={lineChartData}
                        options={{
                            responsive: true,
                            scales: {
                                x: {
                                    display: true,
                                    title: {
                                        display: true,
                                        text: '2024'
                                    }
                                },
                                y: {
                                    display: true,
                                    title: {
                                        display: true,
                                        text: 'Count'
                                    }
                                }
                            }
                        }}
                        width={400}
                        height={100}
                    />
                </CardBody>
                <CardFooter>
                    <div className="card-stats">
                        <i className="fa fa-check" /> Data information certified
                    </div>
                </CardFooter>
            </Card>
        </>
    )
}

export default LineChart;